export const primaryColor: string = '#95c11f';
export const primaryColorLight: string = '#dfedbc';


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/layout/BaseLayout.ts